// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gM","advertCardHeader__actions":"c-a_gN","advertCardHeader__bottomLabel":"c-a_gO"};